module.exports = __webpack_public_path__ + "static/img/mode-media_check@2x.576e6808.png";